import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox']

  toHref (event) {
    event.preventDefault()
    const href = event.currentTarget.dataset.href
    window.location.href = href
  }
}
